import React from "react";
import { createRoot } from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Top from "./pages/Top";
import Settings from "./pages/Settings";
import Calendar from "./pages/Calendar";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Users from "./pages/Users";
import Admin from "./pages/Admin";
import MyPage from "./pages/MyPage";
import "./styles.css";

// Public pages stay accessible when signed out. Auth-only pages use ProtectedRoute.
const router = createHashRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Top /> },
      { path: "/settings", element: <Settings /> },
      { path: "/calendar", element: <Calendar /> },
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
      { path: "/me", element: <MyPage /> },
      { path: "/mypage", element: <MyPage /> },
      {
        path: "/users",
        element: (
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin",
        element: (
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>,
);
